import { useRef, useState } from "react";
import Swal from "sweetalert2";
import AdminLayout from "../layout/AdminLayoutSewa";
import { adminUploadBills } from "../api";

export default function SewaBillsUploaderPage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [recent, setRecent] = useState(null);
  const fileInputRef = useRef(null);

  const clear = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      return Swal.fire({
        icon: "warning",
        title: "Tiada fail",
        text: "Sila pilih fail Excel.",
      });
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", selectedFile);

      const res = await adminUploadBills(formData);

      setRecent({
        uploadedAt: new Date().toLocaleString(),
        fileName: selectedFile.name,
        ...res,
      });

      await Swal.fire({
        icon: "success",
        title: "Berjaya",
        text: "Bills upload selesai.",
      });

      clear();
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "Gagal",
        text: e?.response?.data?.error || "Bills upload gagal.",
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="bg-white p-6 rounded-lg shadow-md max-w-5xl mx-auto">
        <h2 className="text-xl font-bold text-gray-800">Upload Bills</h2>
        <p className="text-sm text-gray-500 mt-1">
          Template wajib: no_akaun, caj_sewa, due_date, template. Optional: paid_at, receipt_no.
        </p>

        {recent && (
          <div className="mt-5 border border-green-200 bg-green-50 rounded-lg p-4">
            <div className="flex justify-between">
              <p className="font-semibold text-green-700">Upload terakhir</p>
              <p className="text-xs text-green-700">{recent.uploadedAt}</p>
            </div>
            <p className="text-sm mt-2">File: {recent.fileName}</p>
            <pre className="text-xs mt-3 bg-white p-3 rounded border overflow-auto">
              {JSON.stringify(recent, null, 2)}
            </pre>
          </div>
        )}

        <div
          className="mt-6 border-2 border-dashed rounded-lg p-8 text-center cursor-pointer hover:border-blue-400 hover:bg-gray-50"
          onClick={() => fileInputRef.current?.click()}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            className="hidden"
            onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
          />
          {selectedFile ? (
            <div>
              <p className="font-medium text-green-700">{selectedFile.name}</p>
              <p className="text-sm text-gray-500 mt-1">Klik untuk tukar fail</p>
            </div>
          ) : (
            <div>
              <p className="font-medium text-gray-700">Klik untuk pilih fail Excel bills</p>
              <p className="text-sm text-gray-500 mt-1">.xlsx / .xls sahaja</p>
            </div>
          )}
        </div>

        <div className="flex justify-between mt-5">
          <button
            className="py-2 px-5 rounded-lg border border-gray-300 text-gray-700"
            onClick={clear}
            disabled={!selectedFile || uploading}
          >
            Clear
          </button>

          <button
            className="py-2 px-5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            onClick={handleUpload}
            disabled={!selectedFile || uploading}
          >
            {uploading ? "Uploading..." : "Upload Bills"}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}